const firebaseConfig = {
    // apiKey: "AIzaSyBT6wP44qD84r-ajCV1ua6WM7ZnYyG5UcY",
    // authDomain: "electro-shop-dashboard.firebaseapp.com",
    // projectId: "electro-shop-dashboard",
    // storageBucket: "electro-shop-dashboard.appspot.com",
    // messagingSenderId: "440596841409",
    // appId: "1:440596841409:web:9c2f40869f231a37636540"

    apiKey: "AIzaSyAa7qiYFg_XzRMX0f_CgtpsJM83ToXJUPs",
    authDomain: "e-shop-b7ee1.firebaseapp.com",
    projectId: "e-shop-b7ee1",
    storageBucket: "e-shop-b7ee1.appspot.com",
    messagingSenderId: "739244304640",
    appId: "1:739244304640:web:a29b17fccdbb01c246ebe5"
};

export default firebaseConfig;